import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import isTextEmpty from '@wix/da-editor-tiptap/pkg/components/utils/isEmpty';
import type { EditorState } from '@wix/da-editor-tiptap/pkg/components/Editor/types';
import { AnswerType } from './types';

const MAX_QUESTION_LENGTH = 1000;

export function useValidation() {
  const { t } = useTranslation();
  const validationSchema = yup.object({
    question: yup
      .object()
      .test(
        'required',
        t('originalDeviationPopup.error.question.required'),
        value => {
          if (!value) {
            return false;
          }
          if (typeof value === 'function') {
            const editorData: EditorState = JSON.parse(value());
            if (editorData) {
              return !isTextEmpty(editorData.document);
            }
          }
          return false;
        }
      )
      .test(
        'editor-max-length',
        t('originalDeviationPopup.error.question.tooLong'),
        value => {
          if (!value) {
            return true;
          }
          if (typeof value === 'function') {
            const v = value();
            if (v) {
              // We use half because html and feature are included in the limit
              return v.length < MAX_QUESTION_LENGTH / 2;
            }
          }
          return true;
        }
      ),
    isRequired: yup.boolean(),
    answerType: yup
      .string()
      .required(t('originalDeviationPopup.error.answerType.required')),
    answerChoices: yup.array().when('answerType', {
      is: (type: AnswerType) => type !== AnswerType.FREE_TEXT,
      then: schema =>
        schema
          .of(
            yup.object().shape({
              answerText: yup
                .string()
                .required(
                  t('originalDeviationPopup.error.answerChoices.required')
                ),
            })
          )
          .min(1, t('originalDeviationPopup.error.answerChoices.required'))
          .required(t('originalDeviationPopup.error.answerChoices.required')),
      otherwise: schema => schema.notRequired(),
    }),
  });
  return validationSchema;
}
